<template>
    <div>
      <div class="nocode-background position">
        <div class="overlay"></div>
        <div class="content"></div>
      </div>
      <div class="login-container position">
        <div class="left-section">
          <div class="left-side-image-box">
            <img src="./register.png" />
          </div>
        </div>
        <div class="right-section">
        <router-view /> <!-- Loads Register or OTP inside layout -->
      </div>
      </div>
    </div>
  </template>
  
  <script>
  // import intlTelInput from 'intl-tel-input';
  import app_config from "@/config/app";
  import axios from "@/config/axios";
  export default {
    name: "NoCodeBackground",
    data() {
      return {
        pageType: 0,
        errorMessage: '',
        value: '',
        application_config: app_config,
        config: {
          overlayColor: 'rgba(0, 0, 0, 0.2)' // Indigo semi-transparent
        },
        defaultLogo: "../../assets/logo.webp",
        company_info: {},
        registration_config: {},
        form: {
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          tenantCode: "",
        },
        iti: null,
  
        showPassword: false,
  
        loading: false,
  
        rules: {
  
          firstName: [{
            required: true,
            message: "First name is required",
            trigger: "blur"
          }],
  
          lastName: [{
            required: true,
            message: "Last name is required",
            trigger: "blur"
          }],
          email: [
            {
              required: true,
              message: "Email is required",
              trigger: "blur"
            },
            {
              type: "email",
              message: "Invalid email format",
              trigger: "blur"
            },
          ],
          tenantCode: [{
            required: true,
            message: "Tenant code is required",
            trigger: "blur"
          }],
        },
      };
    },
  
    // components: {
    //   accessdenied: () => import("./accessdenied.vue"),
    //   AwesomeLoader: () => import("./loader.vue")
    // },
    computed:
    {
      getLogoInfo() {
        return this.company_info && this.company_info.logo ? `${this.application_config.S3_BUCKET_URL}/${this.company_info.logo}` : this.defaultLogo;
      }
    },
  
    created() {
      this.form.tenantCode = this.$route.params.unique_code;
    },
    async mounted() {
      document.documentElement.style.setProperty('--overlay-color', this.config.overlayColor);
      await this.validateCode();
      this.$nextTick(() => {
        this.initPhoneInput();
      });
    },
  
    methods: {
  
      async initPhoneInput() {
        let defaultCountry = await this.getCountryFromAPI();
        const input = this.$refs.phone;
        if (!input || !window.intlTelInput) {
          console.error("intlTelInput or input not found");
          return;
        }
        this.iti = window.intlTelInput(input, {
          initialCountry: defaultCountry || 'auto',
          strictMode: true,
          separateDialCode: true,
          nationalMode: false,
          preferredCountries: ['in', 'us', 'gb'],
          geoIpLookup: async (callback) => {
            if (defaultCountry) {
              callback(defaultCountry); // API country found
              return;
            }
            try {
              const res = await fetch('https://ipinfo.io/json');
              const data = await res.json();
              callback(data?.country ?.toLowerCase() || 'us'); // IP-based or fallback
            } catch (e) {
              console.warn('GeoIP lookup failed:', e);
              callback('us');
            }
          },
          utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@17/build/js/utils.js',
          dropdownContainer: document.body,
          allowDropdown: true,
        });
      },
      async getCountryFromAPI() {
        try {
          return this.registration_config ? 'us' : null;
          // const res = await fetch('/api/tenant-config'); // your real API here
          // const data = await res.json();
          // return data?.default_country?.toLowerCase() || null;
        } catch (error) {
          console.warn('Country API failed:', error);
          return null;
        }
      },
      onlyAllowNumbers(event) {
        const key = event.key;
        const isAllowed = /[0-9]/.test(key) || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(key);
        if (!isAllowed) {
          event.preventDefault();
        }
      },
      emitPhoneNumber() {
        if (this.iti) {
          const number = this.iti.getNumber();
          this.$emit('input', number);
        }
      },
      async validateCode() {
        if (this.form.tenantCode) {
          try {
            this.loading = true;
            let info = await axios.get(`/ap/verify/${this.form.tenantCode}`);
            this.registration_config = info.data.data;
            this.company_info = info.data.data.company_id;
            this.pageType = 1;
            this.loading = false;
            this.errorMessage = "";
          } catch (err) {
            this.loading = false;
            this.pageType = 2;
            this.errorMessage = err?.response?.data?.message || err?.message;
          }
        }
  
      },
      togglePassword() {
        this.showPassword = !this.showPassword;
      },
      async submitForm() {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) return;
          if (!this.iti) return;
          const fieldConfig = this.iti;
          if (!fieldConfig.isValidNumber()) {
            this.$message.error("Invalid Phone nUmber");
            return;
          }
          const countryData = fieldConfig.getSelectedCountryData();
          const nationalNumber = fieldConfig.getNumber(window.intlTelInputUtils.numberFormat.NATIONAL);
          const internationalNumber = fieldConfig.getNumber(window.intlTelInputUtils.numberFormat.INTERNATIONAL);
          const e164Number = fieldConfig.getNumber(window.intlTelInputUtils.numberFormat.E164);
          const uriNumber = fieldConfig.getNumber(window.intlTelInputUtils.numberFormat.RFC3966);
  
          this.form.phone = this.$refs.phone.value
          this.form.phone_code = {
            country: countryData.name,
            iso2: countryData.iso2,
            dialCode: countryData.dialCode,
            nationalNumber,
            internationalNumber,
            e164Number,
            uriNumber
          };
  
          this.loading = true;
          const payload = {
            ...this.form
          };
          delete payload.confirmPassword;
  
          try {
            let info = await axios.post(`/ap/reg/${this.form.tenantCode}`, {
              ...this.form
            });
            setTimeout(() => {
              this.loading = false;
              this.$message.success("Tenant registered successfully!");
              this.$router.push({
                path: `/${this.form.tenantCode}/otp?id=${info.data.contact._id}&mail=${info.data.contact.email}`
              })
              this.resetForm();
            }, 1000);
          } catch (err) {
            this.loading = false;
            this.$message.error(err.response.data.message || err.message);
          }
        });
      },
  
      resetForm() {
        this.form = {
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          tenantCode: "",
        };
      },
    },
    beforeDestroy() {
      if (this.iti) {
        this.iti.destroy();
      }
    }
  };
  </script>
  
  <style>
  .iti {
    position: relative;
    display: inline-block;
    top: -19px;
    left: -7px;
    width: 100%;
    border: 0px;
    z-index: 1000;
  }
  .iti input {
    width: 100%;
  }
  </style>
  <style scoped>
   .position {
    position: absolute;
    top: 0;
  }
  .nocode-background {
    position: relative;
    height: 100vh;
    width: 100%;
    background-image: url("https://img.freepik.com/free-photo/abstract-futuristic-background-with-3d-design_1361-3532.jpg?t=st=1748118013~exp=1748121613~hmac=7b3a3e7761f19e3cfc026571b6816c154b6a060e94b1e466cf9b3ffa4a518b3f&w=1380");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    animation: hueRotateBg 30s infinite linear;
  }
  @keyframes hueRotateBg {
    from {
      filter: hue-rotate(0deg);
    }
  
    to {
      filter: hue-rotate(360deg);
    }
  }

    
  .overlay {
    position: absolute;
    inset: 0;
    background-color: var(--overlay-color);
    z-index: 0;
    transition: background-color 0.3s ease;
  }  
  .content {
    position: relative;
    z-index: 1;
    text-align: center;
    color: white;
    width: 100%;
  }
  .left-side-image-box {
    z-index: 5;
    text-align: center;
    color: white;
    width: 100%;
  }
  .left-side-image-box img {
    max-width: 90%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .login-container {
    display: flex;
    flex-direction: row;
    min-height: 100vh;
    width: 100%;
    /* background-image: url("https://image.bodiscdn.com/parking/landing-hero.png");
      background-size: cover;
      background-position: center; */
    overflow: hidden;
    background-color: rgb(100 100 158 / 28%);
  }
  
  .left-section {
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
    min-height: 100vh;
    align-items: center;
    /* vertical center */
  }
  
  .right-section {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
  }
  
  /* FULL RESPONSIVE FOR MOBILE & TABLET */
  @media (max-width: 1024px) {
    .login-container {
      flex-direction: column;
  
      padding: 1rem;
  
      background-position: top center;
    }
  
    .left-section {
      width: 100%;
  
      padding: 1rem;
  
      text-align: center;
    }
  
    .right-section {
      width: 100%;
  
      padding: 1rem;
    }
  }
  @media (max-width: 1024px) {
    .left-section {
      display: none;
    }
  }
  </style>
  